import cx from 'clsx';

import { MembershipStandardWithWhiteText98x16Icon } from '~/assets/icons';
import { BonuspackClovercon } from '~/assets/icons/membership';

type Props = {
  type: string;
  description: string;
};

export function MembershipBenefitBanner({ type, description }: Props) {
  return (
    <div
      className={cx([
        'flex w-full items-center h-full justify-center gap-6 py-6',
        type === 'PLUS_MEMBERSHIP_WEEK' && 'bg-plusmembership-event-badge',
        type === 'LUCKY_BONUS_PACK' && 'bg-bonuspackGreen-background',
      ])}
    >
      {type === 'PLUS_MEMBERSHIP_WEEK' ? (
        <MembershipStandardWithWhiteText98x16Icon />
      ) : (
        <BonuspackClovercon />
      )}
      <p className="text-inverse typo-paragraph100-semibold">{description}</p>
    </div>
  );
}
